// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Tssg","notes":"Notes_notes__M3fOD"};